var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 0H10.75C10.3125 0 10 0.34375 10 0.75C10 1.1875 10.3125 1.5 10.75 1.5H12.4375L9.78125 4.15625C8.8125 3.40625 7.65625 3 6.5 3C5.0625 3 3.65625 3.5625 2.59375 4.625C0.4375 6.78125 0.4375 10.25 2.59375 12.4062C3.65625 13.4688 5.0625 14 6.5 14C7.90625 14 9.28125 13.4688 10.375 12.4062C12.3438 10.4375 12.5 7.375 10.8438 5.21875L13.5 2.5625V4.25C13.5 4.6875 13.8125 5 14.25 5C14.6562 5 15 4.6875 15 4.25V0.75C15 0.34375 14.6562 0 14.25 0ZM9.3125 11.3438C8.5625 12.0938 7.5625 12.5 6.5 12.5C5.40625 12.5 4.40625 12.0938 3.65625 11.3438C2.09375 9.78125 2.09375 7.25 3.65625 5.6875C4.40625 4.9375 5.40625 4.5 6.5 4.5C7.5625 4.5 8.5625 4.9375 9.3125 5.6875C10.875 7.25 10.875 9.78125 9.3125 11.3438Z",
    fill: "#6F7F93"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.9a4c2e22075a134822712818dfd113f1.svg";
export { ForwardRef as ReactComponent };